import { render, staticRenderFns } from "./NAO_Parques.vue?vue&type=template&id=e5272932&"
import script from "./NAO_Parques.vue?vue&type=script&lang=js&"
export * from "./NAO_Parques.vue?vue&type=script&lang=js&"
import style0 from "./NAO_Parques.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports